import { type IntegrationData } from 'src/shared/api/integrations/factorial';

export type Params = {
  integrationName: string;
};

type IntegrationKey = keyof typeof integrationsList;

type GetIsAbleToSyncArgs = {
  integrationName: string;
  software?: string;
  subsidiary?: string;
  integrationData?: IntegrationData[];
};

const integrationsList = {
  factorial: 'factorial',
  a3api: 'a3apiv2',
  grupoCastillaEpsilon: 'castilla'
};

export const getIntegrationNameFix = (softwareName?: string) => {
  const intergationNameFix = integrationsList[softwareName as IntegrationKey] ?? softwareName;
  return intergationNameFix;
};

export const getIsAbleToSync = ({ integrationName, subsidiary, integrationData }: GetIsAbleToSyncArgs) => {
  const isAbleToSync =
    integrationData?.some(e => e.software === getIntegrationNameFix(integrationName)) &&
    integrationData?.some(e => e.subsidiary === subsidiary && e.flowsEnabled?.batchEmployeeSync);

  return isAbleToSync;
};
